import React from "react";
import { NavLink } from "react-router-dom";

import Analytics from "../Shared/Svgs/Analytics";
import Logout from "../Shared/Svgs/Logout";
import Projects from "../Shared/Svgs/Projects";

import ProfileActions from "./ProfileActions/ProfileActions";

const Nav = () => {
    const handleLogout = () => {
        console.log("Handle logout");
    };

    return (
        <div className="Nav">
            <div className="navActions">
                <div className="navMenu">
                    <ProfileActions />
                    <NavLink
                        to="/dashboard"
                        className={({ isActive }) =>
                            isActive
                                ? "navLink active"
                                : "navLink"
                        }
                    >
                        <Analytics />
                        <b>DASHBOARD</b>
                    </NavLink>
                    <NavLink
                        to="/projects"
                        className={({ isActive }) =>
                            isActive
                                ? "navLink active"
                                : "navLink"
                        }
                    >
                        <Projects />
                        <b>PROJECTS</b>
                    </NavLink>
                    <div
                        onClick={handleLogout}
                        className="navLink"
                    >
                        <Logout />
                        <b>LOG OUT</b>
                    </div>
                </div>
            </div>

            <div className="navFooter">
                <img
                    src="/images/logo.svg"
                    className="logo"
                    alt="logo"
                />
            </div>
        </div>
    );
};

export default Nav;
